import { Controller, useFormContext, useWatch } from 'react-hook-form';
import type { ProgramEditorValues } from '@features/programs';
import { InfoIcon } from '@shared/assets/index.ts';
import { useAppDispatch } from '@shared/hooks/index.ts';
import { Card, Toggle } from '@shared/ui';
import { openNotifyModal } from '@src/library/redux/modal/index.ts';
import * as st from './styles.module.scss';

export const EditorSchedule = (): JSX.Element => {
  /**
   * TODO:  Разобраться с условиями при которых disabled
   */
  const dispatch = useAppDispatch();
  const { control } = useFormContext<ProgramEditorValues>();
  const isEnabledPeriodicity = useWatch({ name: 'schedule', control });

  const onIconClick = () => {
    dispatch(
      openNotifyModal({
        title: 'Расписание',
        text: `Функция "Расписание" позволяет настроить открытие доступа к видео, указывая конкретные дату и время, когда оно станет доступным для просмотра.`,
        confirmText: 'Понятно',
        buttonClassName: st.notifyButton,
        fullWidthText: true,
      })
    );
  };

  return (
    <fieldset>
      <div className={st.header}>
        <h3>Расписание</h3>
        <InfoIcon className={st.icon} onClick={onIconClick} />
      </div>
      <Card className={st.schedule}>
        <div className={st.wrapper}>
          <span>{isEnabledPeriodicity ? 'Включено' : 'Отключено'}</span>
          <Controller
            name="schedule"
            control={control}
            render={({ field: { value, onChange } }) => (
              <Toggle
                value={value}
                onToggle={(value) => {
                  onChange(value);
                }}
              />
            )}
          />
        </div>
      </Card>
    </fieldset>
  );
};
